import { PayloadAction } from "@reduxjs/toolkit";
import { DealerRecordStatusEnum, DealerSliceState, IDealer } from "../types";
import { sanitizeBranchColumnsHideList } from "../../lib/sanitizeBranchColumnsHideList";

export const branchesReducers = {
  sortDealerBranchesList: (
    state: DealerSliceState,
    action: PayloadAction<{ field: keyof IDealer | null; type: string | null }>,
  ) => {
    const nameSort: keyof IDealer | null = action.payload.field;
    const typeSort = action.payload.type;
    if (nameSort && typeSort !== null && state.branchesList.length > 1) {
      state.branchesList = state.branchesList.sort(
        (branch1, branch2): number => {
          if (typeSort === "asc") {
            return branch1[nameSort]! > branch2[nameSort]! ? 1 : -1;
          } else if (typeSort === "desc") {
            return branch1[nameSort]! < branch2[nameSort]! ? 1 : -1;
          } else {
            return 0;
          }
        },
      );
    }
  },
  searchDealerBranch: (
    state: DealerSliceState,
    action: PayloadAction<string>,
  ) => {
    const payload = action.payload.toString().toLowerCase();
    const newList = state.currentDealerBranchesForFilter.filter((dealer) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { isMain, id, status, ...searchFields } = dealer;
      if (
        status &&
        status === 1 &&
        DealerRecordStatusEnum._1.toLowerCase().includes(payload)
      )
        return true;
      if (
        status &&
        status === 2 &&
        DealerRecordStatusEnum._2.toLowerCase().includes(payload)
      )
        return true;
      if (
        status &&
        status === 3 &&
        DealerRecordStatusEnum._3.toLowerCase().includes(payload)
      )
        return true;
      if (
        status &&
        status === 4 &&
        DealerRecordStatusEnum._4.toLowerCase().includes(payload)
      )
        return true;
      if (
        status &&
        status === 5 &&
        DealerRecordStatusEnum._5.toLowerCase().includes(payload)
      )
        return true;
      return !!Object.values(searchFields).find(
        (value) =>
          value !== null && value.toString().toLowerCase().includes(payload),
      );
    });
    state.branchesList = payload
      ? newList
      : state.currentDealerBranchesForFilter;
  },
  setCurrentBranch: (
    state: DealerSliceState,
    action: PayloadAction<string>,
  ) => {
    state.currentDealerBranch = state.branchesList.find(
      (d) => d.id === action.payload,
    );
  },
  setBranchColumnsToHide: (
    state: DealerSliceState,
    action: PayloadAction<(keyof IDealer | string)[]>,
  ) => {
    state.hideBranchesColumnsList = sanitizeBranchColumnsHideList(
      action.payload,
      state.excludeItems,
    );
  },
  setSortRules: (
    state: DealerSliceState,
    action: PayloadAction<DealerSliceState["branchesSort"]>,
  ) => {
    state.branchesSort = action.payload;
  },
};
